import styled from 'styled-components';

const DisconnectIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export default function DisconnectIcon() {
  return (
    <DisconnectIconSvg viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M4 4l8 8M12 4l-8 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </DisconnectIconSvg>
  );
}
